import Data from "./data.vue";

export default Data;



// WEBPACK FOOTER //
// ./src/components/_data/index.js